import { render, staticRenderFns } from "./LaoGlowExtra.vue?vue&type=template&id=1a5ad52c&"
import script from "./LaoGlowExtra.vue?vue&type=script&lang=js&"
export * from "./LaoGlowExtra.vue?vue&type=script&lang=js&"
import style0 from "./LaoGlowExtra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports